module.exports = __webpack_public_path__ + "img/feedback.b2c21efa.svg";